import type { PaginationResponse } from 'api/types/common/PaginationResponse';

/** Resolve total matching listings from API pagination metadata. */
export function resolveTotalRecordCount(
  pagination: PaginationResponse | null | undefined,
  currentPageItemCount: number
): number {
  if (pagination?.totalRecordCount != null && pagination.totalRecordCount >= 0) {
    return pagination.totalRecordCount;
  }
  if (!pagination || pagination.totalPageCount <= 1) {
    return currentPageItemCount;
  }
  const { pageNumber, pageSize, totalPageCount } = pagination;
  if (pageNumber === totalPageCount) {
    return (totalPageCount - 1) * pageSize + currentPageItemCount;
  }
  return currentPageItemCount;
}
